import Card from "@mui/material/Card";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import { BsCheckCircleFill } from "react-icons/bs";
import { FaBell, FaBed, FaUserCheck } from "react-icons/fa";
import { IoExitOutline } from "react-icons/io5";
import { BsClipboardCheckFill } from "react-icons/bs";
import { MdBedroomParent } from "react-icons/md";

import TimelineItem from "examples/Timeline/TimelineItem";
import palette from "assets/theme/base/colors";

function getTimelineIcon(type) {
  switch (type) {
    case "arrival":
      return <FaUserCheck size="16px" color={palette.info.main} />;
    case "departure":
      return <IoExitOutline size="16px" color={palette.warning.main} />;
    case "request":
      return <FaBell size="16px" color={palette.error.main} />;
    case "preferences":
      return <BsClipboardCheckFill size="16px" color={palette.success.main} />;
    case "occupancy":
      return <MdBedroomParent size="16px" color={palette.lightblue.main} />;
    case "returning":
      return <FaBed size="16px" color={palette.primary.focus} />;
    default:
      return <FaBell size="16px" color={palette.info.main} />;
  }
}

function OrdersOverview({
  title = "Operations Overview",
  growthText = "+12%",
  growthSubText = "from yesterday",
  items = [],
}) {
  return (
    <Card sx={{ height: "100%" }}>
      <VuiBox mb="16px">
        <VuiTypography variant="lg" fontWeight="bold" mb="5px">
          {title}
        </VuiTypography>

        <VuiBox mb={0}>
          <VuiBox display="flex" alignItems="center">
            <BsCheckCircleFill color="green" size="15px" />
            <VuiTypography variant="button" fontWeight="medium" ml="5px" mr="4px">
              {growthText}
            </VuiTypography>
            <VuiTypography variant="button" fontWeight="regular">
              {growthSubText}
            </VuiTypography>
          </VuiBox>
        </VuiBox>
      </VuiBox>

      <VuiBox>
        {items.map((item, index) => (
          <TimelineItem
            key={index}
            icon={getTimelineIcon(item.type)}
            title={item.title}
            dateTime={item.dateTime}
          />
        ))}
      </VuiBox>
    </Card>
  );
}

export default OrdersOverview;
